import VendorsListSection from './VendorsListSection';

export default VendorsListSection;
